"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnimatedEmoji = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const remotion_1 = require("remotion");
const calculate_emoji_src_1 = require("./calculate-emoji-src");
const emoji_data_1 = require("./emoji-data");
const is_webkit_1 = require("./is-webkit");
const AnimatedEmoji = ({ emoji, scale = '1', calculateSrc = calculate_emoji_src_1.defaultCalculateEmojiSrc, playbackRate = 1, ...props }) => {
    const { fps } = (0, remotion_1.useVideoConfig)();
    const emojiData = emoji_data_1.emojis.find((e) => e.name === emoji);
    if (!emojiData) {
        throw new Error(`Emoji ${emoji} not found. Available emojis: ${emoji_data_1.emojis.map((e) => e.name).join(', ')}`);
    }
    return ((0, jsx_runtime_1.jsx)(remotion_1.Loop, { layout: "none", durationInFrames: Math.floor((emojiData.durationInSeconds * fps) / playbackRate), children: (0, jsx_runtime_1.jsx)(remotion_1.OffthreadVideo, { ...props, muted: true, transparent: true, playbackRate: playbackRate, src: calculateSrc({ emoji, scale, format: (0, is_webkit_1.isWebkit)() ? 'hevc' : 'webm' }) }) }));
};
exports.AnimatedEmoji = AnimatedEmoji;
